import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { OInlineMessage as OInlineMessageComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

export const OInlineMessageConfig = {
  emptyLabel: 'OInlineMessage',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-inline-message`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OInlineMessage = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;
  const custom_click_track_value = props.custom_click_track_value ?? props.clickTrackValue ?? model.clickTrackValue;

  return (
    <div
      data-testid="o-inline-message-comp"
      data-component-name="o-inline-message"
      id={componentId}
      className={clsx(styleclass)}
    >
      <EditableComponent config={OInlineMessageConfig} {...props}>
        <OInlineMessageComp {...props} custom_click_track_value={custom_click_track_value} />
      </EditableComponent>
    </div>
  );
};
